// src/components/common/Layout.js
import React from 'react';
import Navbar from './NavBar';
import Footer from './Footer';
import NotificationProvider from '../notifications/NotificationProvider';

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen relative bg-primary-bg">
      <Navbar />
      <NotificationProvider>
        <main className="flex-1 pt-16 w-full relative z-[1] bg-primary-bg">
          {children}
        </main>
      </NotificationProvider>
      <Footer />
    </div>
  );
};

export default Layout;
